import { FeatureDefinition } from '../entities';

export const skipTrialChoiceFeature = 'remove_trial_choice_appnebula_0726';

export const skipTrialChoiceFeatureConfig: FeatureDefinition = {
  defaultValue: true,
};
